import { render } from "./myLuckydrawTwo.vue?vue&type=template&id=a8fda682&scoped=true"
import script from "./myLuckydrawTwo.vue?vue&type=script&lang=js"
export * from "./myLuckydrawTwo.vue?vue&type=script&lang=js"

import "./myLuckydrawTwo.vue?vue&type=style&index=0&id=a8fda682&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8fda682"]])

export default __exports__